import React, { Component } from 'react'
import { DetectDiseaseRes, DetectDiseaseTodo } from 'redux/slice/admin/text-report/DetectDisease';
import { connect } from 'react-redux';
import 'react-perfect-scrollbar/dist/css/styles.css';
import { toast } from 'react-toastify';
import { Table } from 'reactstrap';
import { Button } from 'react-bootstrap';
import { FaRegFilePdf } from 'react-icons/fa';
import { GenrateDiseaseRes, GenrateDiseaseTodo } from 'redux/slice/admin/text-report/GenrateDiseasePdf';

class DetectDiseaseForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            // predictionsRes: null,
            predictionData: this.props.predictionsRes,
            spiner: false,
            pdfSpiner: false,
        }
    }

    detect_disease = () => {
        const { dispatch, testtypeval, reportRes } = this.props;
        this.setState({ spiner: true });
        const data = {
            "company_id": localStorage.getItem('companyId'),
            "cell_counts": {
                "Platelets": reportRes?.cell_counts?.Platelets,
                "RBC": reportRes?.cell_counts?.RBC,
                "WBC": reportRes?.cell_counts?.WBC
            },
            "test_type": testtypeval,
            "test_parameters": {
                "Eosinophil_Count": "0.2 x10^9/L",
                "Hematocrit": "42.0 %",
                "Hemoglobin": "14.0 g/dL",
                "Lymphocyte_Count": "1.5 x10^9/L",
                "MCV": "1.5 x10^9/L",
                "Monocyte_Count": "90.0 fL",
                "Neutrophil_Count": "3.0 x10^9/L",
                "Platelet_Count": "100000 x10^9/L",
                "RDW": "13.0 %",
                "Red_blood_counts": "13 x10^12/L",
                "White_blood_counts": "1x10^9/L"
            }
        }
        dispatch(DetectDiseaseTodo(data)).then(() => this.detecte_res())
    }
    detecte_res = () => {
        if (DetectDiseaseRes?.success) {
            this.setState({
                spiner: false,
                // predictionData: DetectDiseaseRes?.data

            });
            this.props.updateState(DetectDiseaseRes?.data);

            toast.success(DetectDiseaseRes?.message, { position: "bottom-right" });
        } else {
            toast.error(DetectDiseaseRes?.message, { position: "bottom-right" });
            this.setState({ spiner: false });
        }
    }


    genrate_disease = () => {
        const { dispatch, testtypeval, reportRes } = this.props;
        // const { reportRes, testtypeval } = this.state;

        this.setState({ pdfSpiner: true });
        const data = {
            "company_id": localStorage.getItem('companyId'),
            "cell_counts": {
                "Platelets": reportRes?.cell_counts?.Platelets,
                "RBC": reportRes?.cell_counts?.RBC,
                "WBC": reportRes?.cell_counts?.WBC
            },
            "test_type": testtypeval.toString(),
            "test_parameters": {
                "Eosinophil_Count": "0.2 x10^9/L",
                "Hematocrit": "42.0 %",
                "Hemoglobin": "14.0 g/dL",
                "Lymphocyte_Count": "1.5 x10^9/L",
                "MCV": "1.5 x10^9/L",
                "Monocyte_Count": "90.0 fL",
                "Neutrophil_Count": "3.0 x10^9/L",
                "Platelet_Count": "100000 x10^9/L",
                "RDW": "13.0 %",
                "Red_blood_counts": "13 x10^12/L",
                "White_blood_counts": "1x10^9/L"
            }
        }
        dispatch(GenrateDiseaseTodo(data)).then(() => this.detecte_res2())
    }
    detecte_res2 = () => {
        if (GenrateDiseaseRes?.success) {
            this.setState({
                pdfSpiner: false
            });

            window.open(GenrateDiseaseRes?.data, '_blank');
            toast.success(GenrateDiseaseRes?.message, { position: "bottom-right" });
        } else {
            toast.error(GenrateDiseaseRes?.message, { position: "bottom-right" });
            this.setState({ pdfSpiner: false });
        }
    }

    render() {
        const { reportRes, predictionsRes } = this.props;
        const { spiner, predictionData } = this.state;
        // console.log("predictionsRes", predictionData)
        console.log("reportRes", reportRes)
        return (
            <>
                {
                    reportRes ? <div className="disease_layout" >
                        <div className='p-3'>
                            <div className="row">
                                <div className='d-flex justify-content-between mb-1'>
                                    <h3 className=''>Test No.: {this.props.testtypeval}</h3>
                                    <Button variant='primary' type='button' className='add_btn2' size='sm' onClick={this.genrate_disease} >

                                        {this.state?.pdfSpiner ? <>   <span className="spinner-border spinner-border-sm" aria-hidden="true"></span>
                                        </> : <span >    Download Report <FaRegFilePdf className='mb-1' /> </span>}
                                    </Button>
                                </div>
                                <div className="table-responsive">
                                    <Table className="table table-bordered mb-0">
                                        <thead>
                                            <tr>
                                                <th>Investigation</th>
                                                <th>Result</th>
                                                <th>Reference Value</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <th >RED BLOOD CELL (RBC) COUNT</th>
                                                <td style={{ fontSize: "18px", fontWeight: "600" }}>{reportRes?.cell_counts?.RBC ? reportRes?.cell_counts?.RBC : '0'}</td>
                                                <td>4.70 - 6.10 (mill/cumm)</td>
                                            </tr>
                                            <tr>
                                                <th >WHITE BLOOD CELL (WBC) COUNT</th>
                                                <td style={{ fontSize: "18px", fontWeight: "600" }}>{reportRes?.cell_counts?.WBC ? reportRes?.cell_counts?.WBC : "0"}</td>
                                                <td>4.50 - 11.00 (mill/cumm)</td>
                                            </tr>
                                            <tr>
                                                <th > PLATELETS COUNT</th>
                                                <td style={{ fontSize: "18px", fontWeight: "600" }}>{reportRes?.cell_counts?.Platelets ? reportRes?.cell_counts?.Platelets : "0"}</td>
                                                <td>150.00 - 450.5 (mill/cumm)</td>
                                            </tr>
                                        </tbody>
                                    </Table>
                                </div>

                                <div className="col-md-12 mt-1 text-center" >
                                    <button className="btn rbc_btn btn-block ps-3 pe-3 " onClick={this.detect_disease} type="button" disabled={this.state?.spiner ? true : false} >
                                        {this.state?.spiner ? <>  <span className='ps-1'>Loading....</span> <span className="spinner-border spinner-border-sm" aria-hidden="true"></span>
                                        </> : <span >  DETECT DISEASE </span>}
                                    </button>
                                </div>
                            </div>
                        </div>




                    </div>
                        : ''}

            </>
        )
    }
}
export default connect()(DetectDiseaseForm);



{/* <div className="col-md-6">
                                <div className='prediction_sec '>

                                    <h3 className='ps-3 pe-3 pt-2'>Possible Diseases</h3>
                                    <div className='scroll_sec '>
                                        <PerfectScrollbar >
                                            <div className=' pe-4 ps-4 pb-2'>
                                                {predictionsRes?.disease_predictions?.diseases?.map((val, index) =>
                                                    <div className='prediction_2 mt-1' key={index}>
                                                        <h5 className="text-primary">{val?.name}</h5>
                                                        <div className="text-muted">
                                                            {val?.symptoms?.map((val2, index2) =>
                                                                <p className="mb-1" style={{ color: 'black' }} key={index2}>
                                                                    <i className="mdi mdi-circle-medium align-middle text-primary me-1" />{" "}
                                                                    {val2}
                                                                </p>
                                                            )}
                                                        </div>
                                                    </div>
                                                )}

                                            </div>
                                        </PerfectScrollbar>
                                    </div>
                                </div>
                            </div> */}